import { LockOpenCheckIcon } from './LockOpenCheckIcon';

/**
 * author: François Risoud
 * id 5ED06AF8-75C7-4AC3-962E-F742236AFDA6
 * name lock-open-check
 * version: 5.0.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-open-check.svg
 * tags
 * - Lock 
 */
export const DecryptedCheckIcon = LockOpenCheckIcon;
export default DecryptedCheckIcon